import { render, staticRenderFns } from "./LandsideFooterOld.vue?vue&type=template&id=ed78ac6a&scoped=true&"
import script from "./LandsideFooterOld.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideFooterOld.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandsideFooterOld.vue?vue&type=style&index=0&id=ed78ac6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed78ac6a",
  null
  
)

export default component.exports